import { render, staticRenderFns } from "./CustomBootstrapGroup.vue?vue&type=template&id=3f5fb600&scoped=true&"
import script from "./CustomBootstrapGroup.vue?vue&type=script&lang=js&"
export * from "./CustomBootstrapGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomBootstrapGroup.vue?vue&type=style&index=0&id=3f5fb600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fb600",
  null
  
)

export default component.exports